import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getLeaguePointsRewardLevels = () =>
  call(websocketFetch, 'get_league_points_reward_levels');
